<template>
  <div class="report">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="mb-3">
                <label for="report" class="form-label required">起始時間</label>
                <input
                  v-model="form.started_at"
                  type="datetime-local"
                  class="form-control"
                  id="report"
                  required
                  :max="new Date().format('yyyy-MM-ddThh:mm')"
                />
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="mb-3">
                <label for="report" class="form-label required">結束時間</label>
                <input
                  v-model="form.ended_at"
                  type="datetime-local"
                  class="form-control"
                  id="report"
                  required
                  :min="form.started_at"
                  :max="new Date().format('yyyy-MM-ddThh:mm')"
                />
              </div>
            </div>
          </div>
          <div class="alert alert-danger" role="alert" v-if="hasValidation">
            起始時間與結束時間不可相同
          </div>
          <button class="btn btn-primary" @click="create">匯出</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { report } from '@/http/api/report.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

export default {
  name: 'Report',
  components: {
    Title,
    Breadcrumb
  },
  data () {
    return {
      hasValidation: false,
      form: {
        started_at: new Date().format('yyyy-MM-ddThh:mm'),
        ended_at: new Date().format('yyyy-MM-ddThh:mm')
      }
    }
  },
  computed: {
    ...mapState(['token'])
  },
  watch: {},
  methods: {
    ...mapMutations([
      'Loading',
      'Loaded',
      'AlertsInfo',
      'Alerted',
      'SetRouterName',
      'SetErrMsg',
      'SetErrMsgKey'
    ]),
    ...mapGetters(['errMsgInfo']),
    create () {
      const vm = this
      if (vm.form.started_at === vm.form.ended_at) {
        vm.hasValidation = true
        setTimeout(() => {
          vm.hasValidation = false
        }, 5000)
        return
      }
      vm.form.started_at = new Date(vm.form.started_at).format(
        'yyyy-MM-dd hh:mm'
      )
      vm.form.ended_at = new Date(vm.form.ended_at).format('yyyy-MM-dd hh:mm')
      vm.Loading()
      report
        .create(vm.form, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.get(data.data.report_id)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    get (key) {
      const vm = this
      report
        .get(key, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201) {
            switch (data.status) {
              case 'failed':
                vm.SetErrMsg(data.errMsg)
                vm.AlertsInfo({
                  state: 'error',
                  title: '報表匯出失敗',
                  info: vm.errMsgInfo
                })
                vm.Alerted()
                vm.Loaded()
                break
              case 'pending':
                setTimeout(() => {
                  vm.get(key)
                }, 3000)
                break
              case 'success':
                window.location.assign(data.link)
                vm.Loaded()
                break
            }
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
            vm.Loaded()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {}
}
</script>
